import { useContext } from "react";

import FooterClasses from './AppFooter.module.css';
import { NavLink } from "react-router-dom";

const XYZLABS_Footer = () => {

    return (
        <footer >
		
		   <div className={FooterClasses.appFooterSp}> 
			    <p>Can’t find the right test you need? Got questions about drug testing?
			        <br />
			        Call us <span className={FooterClasses.phone}> </span> -- we're here to help! (customizable)
			    </p>
			</div>
        </footer>
    );
};

export default XYZLABS_Footer;